/* global document, window */
import { useState, useEffect } from 'react';

/* function takes in a target element to observe and waits for an attribute to change within the target */
export default function useMutationObserver(targetElementId, attributeName) {
  const [isMutated, setMutated] = useState(false);
  function callback(mutationList) {
    mutationList.forEach(mutation => {
      switch (mutation.type) {
        case 'attributes':
          try {
            if (mutation.attributeName === attributeName) {
              setMutated(true);
            }
          } catch (error) {
            /* do nothing*/
          }
          break;
        // add more cases if using more mutation types
        default:
          break;
      }
    });
  }

  /* add more mutation types if desired to observe more for ex) childList, subtree etc... */
  const config = {
    attributes: true
  };
  useEffect(() => {
    if ('MutationObserver' in window) {
      const targetNode = document.getElementById(targetElementId);
      const observer = new window.MutationObserver(callback);
      if (targetNode) {
        try {
          observer.observe(targetNode, config);
        } catch (error) {
          /* do nothing */
        }
      }
      return () => {
        observer.disconnect();
      };
    }
    return false;

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [config, targetElementId, attributeName]);
  return isMutated;
}